module.exports = __webpack_public_path__ + "fonts/VetoSansCond-LightItalic_1.c78598c3.eot";